module.exports = __webpack_public_path__ + "static/media/page_05_leaf.413745c2.png";